module.exports = __webpack_public_path__ + "media/npc_dota_hero_ancient_apparition.f9cf3d9d.webm";